class GnlKullaniciAyarDTO {
    id?: number;
    tip?: number;
    kullaniciId?: number;
    ayar?: string;
    ekleyenKullanici?: number;
    eklemeTarihi?: string;
}
export default GnlKullaniciAyarDTO;